import { render, staticRenderFns } from "./Faults.vue?vue&type=template&id=5aebb380"
import script from "./Faults.vue?vue&type=script&lang=js"
export * from "./Faults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports